


import {GET_FillMonthYr} from '../constants/ActionTypes'

const INIT_STATE = {
    MonthYr: null,
    //Message1: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillMonthYr:
                return {
                    MonthYr: action.body,
                    //Message1:action.msg
                  
                }
        default:
            return state;
    }
}